import React from 'react';
import { withAppContext } from '../../contexts/AppContext';
import './PacketaDpm.css';

class PacketaDpm extends React.Component {
    
    static mapData = {
        packeta_point_id: '',
        packeta_point_address: '',
    }

    constructor(props) {
        super(props);
        
        this.state = {
            show: true,
            scriptLoaded: false,
            selectedPoint: props.initialData || null, // Kiválasztott csomagpont adatai
        };

        this.appRef = props.appContext.appRef;
    }

    static handle_packeta_change(point) {
        if (point && point.id) {
            const packeta_address = point.zip + ' ' + point.city + ', ' + point.street + ' (' + point.place + ')';
            
            const newMapData = {
                packeta_point_id: point.id,
                packeta_point_address: packeta_address,
            };
            
            // Frissítjük a statikus mapData-t (kompatibilitás miatt)
            Object.assign(this.mapData, newMapData);
            
            // Frissítjük a komponens state-jét
            if (window.PacketaDpmInstance) {
                window.PacketaDpmInstance.setState({ selectedPoint: newMapData });
                
                // Ha van onSelectionChange callback, meghívjuk
                if (window.PacketaDpmInstance.props.onSelectionChange) {
                    window.PacketaDpmInstance.props.onSelectionChange(newMapData);
                }
            }
        }
    }

    componentDidMount() {
        window.PacketaDpmInstance = this;
        this.loadPacketaScript();
    }

    componentDidUpdate(prevProps) {
        // Ha az initialData prop megváltozott, frissítjük a state-et
        const prevPointId = prevProps.initialData?.packeta_point_id;
        const newPointId = this.props.initialData?.packeta_point_id;
        
        if (prevPointId !== newPointId) {
            this.setState({ selectedPoint: this.props.initialData });
        }
    }

    loadPacketaScript() {
        const { fullFormResponse } = this.props;
        
        // Ellenőrizzük hogy van-e API key
        if (!this.appRef.current.state.settings.packeta_api_key) {
            console.error('Packeta API key missing');
            return;
        }

        if (typeof this.appRef.current.third_party['packeta-widget'] === 'undefined') {
            this.appRef.current.third_party['packeta-widget'] = {};
        }
    
        if (typeof this.appRef.current.third_party['packeta-widget']['loaded'] === 'undefined') {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://widget.packeta.com/v6/www/js/library.js';
            
            const handleScriptLoad = () => {
                this.appRef.current.third_party['packeta-widget']['loaded'] = true;
                this.setState({ scriptLoaded: true });
            };
            
            script.addEventListener('load', handleScriptLoad);
            script.addEventListener('error', (e) => {
                console.error('Packeta widget script load error:', e);
            });

            document.head.appendChild(script);
            
            // Fallback: ellenőrizzük, hogy megjelent-e a Packeta objektum
            let checkCount = 0;
            const checkInterval = setInterval(() => {
                checkCount++;
                
                if (window.Packeta || checkCount > 20) {
                    clearInterval(checkInterval);
                    if (window.Packeta) {
                        handleScriptLoad();
                    } else {
                        console.error('Packeta widget not found after timeout');
                    }
                }
            }, 500);
        } else {
            // Script már betöltődött
            this.setState({ scriptLoaded: true });
        }
    }

    openPacketaWidget = () => {
        const { fullFormResponse } = this.props;
        
        if (!window.Packeta || !this.appRef.current.state.settings.packeta_api_key) {
            console.error('Packeta widget not available');
            return;
        }

        const packetaApiKey = this.appRef.current.state.settings.packeta_api_key;
        
        const packetaOptions = {
            country: "hu",
            language: "hu",
            packetConsignment: "true"
        };

        const showSelectedPickupPoint = (point) => {
            PacketaDpm.handle_packeta_change(point);
        };
        
        window.Packeta.Widget.pick(packetaApiKey, showSelectedPickupPoint, packetaOptions);
    }

    // Kiválasztott csomagpont adatainak lekérése (a Form számára)
    getFormData() {
        return this.state.selectedPoint || {};
    }

    render() { 
        const { show, scriptLoaded, selectedPoint } = this.state;

        if (!show) return null;
        
        // Megvárjuk a script betöltését
        if (!scriptLoaded) {
            return <div className="packeta_chooser">Packeta betöltése...</div>;
        }
        
        return (
            <div className="packeta_chooser">
                <button 
                    type="button" 
                    className="packeta_select_button"
                    onClick={this.openPacketaWidget}
                >
                    {selectedPoint ? 'Csomagpont módosítása' : 'Csomagpont kiválasztása'}
                </button>
                
                {selectedPoint && selectedPoint.packeta_point_address && (
                    <div className="packeta_selected_point_container">
                        <div className="packeta_selected_point_address">
                            {selectedPoint.packeta_point_address}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
 
export default withAppContext(PacketaDpm);
